import { OnInit, Input, Component, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IbgeService } from '../../services/ibge.service';
import { Util } from '../../utils/util';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'municipio',
    templateUrl: './municipio.component.html',
    styleUrls: ['./municipio.component.scss']
})
export class MunicipioFormComponent implements OnInit {

    public cities: any;

    @Input() pageMode: any;

    @Input() municipioTitle = 'Municipio';

    @Input() group: FormGroup;

    @Input() obrigatorio = false;

    // Output para informar que a lista está carregada
    @Output() citiesListLoadedEvent = new EventEmitter();

    MSG_CAMPO_OBRIGATORIO = Util.getMensagemCampoObrigatorio();

    constructor(
        private _ibgeService: IbgeService
    ) { }

    ngOnInit() {
        this.onChanges();
    }

    /**
     * Busca uma lista de municípios de acordo com a UF informada.
     */
    private getListMunicipios(codIBGE): void {
        if (codIBGE) {
            this._ibgeService.getListMunicipios(codIBGE)
                .subscribe(dados => {
                    if (dados) {
                        this.cities = Util.orderBy(dados, 'Nome');
                    } else {
                        this.cities = [];
                    }
                    this.group.get('Endereco.Municipio.CodigoIBGE').setValue(-1);
                    this.emitListLoadedEvent();
                });
        }
    }

    /**
     * Emite informando que a lista está atualizada
     */
    private emitListLoadedEvent() {
        this.citiesListLoadedEvent.emit();
    }

    /**
     * Método que controla as alterações feitas na lista de estados.
     */
    private onChanges(): void {
        const ufComponent = this.group.get('Endereco.Municipio.UF.CodigoIBGE');
        if (ufComponent) {
            ufComponent.valueChanges.subscribe(codIBGE => {
                if (codIBGE === -1) {
                    this.cities = [];
                    this.group.get('Endereco.Municipio.CodigoIBGE').setValue(-1);
                } else {
                    this.getListMunicipios(codIBGE);
                }
            });
        }
    }

    // Método necessário para setar o nome do Municipio quando mudar a opção selecionada
    onChangeMunicipio(codigoIBGE) {
        if (!!this.group.get('Endereco.Municipio.Nome') && this.cities) {
            const municipioSelecionado = this.cities.find(x => x.CodigoIBGE === codigoIBGE);

            if (municipioSelecionado) {
                this.group.get('Endereco.Municipio.Nome').setValue(municipioSelecionado.Nome);
            }
        }
    }
}
